




















import Vue from "vue";

const enabledTextColor = "black"
const disabledTextColor = "graytext"

interface StyleObject {
  color: string
}

export default Vue.extend({
  props: {
    value: Boolean,
    id: String,
    type: String,
    label: String,
    classes: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLabel(): boolean {
      return !!this.label;
    },
    iosStyle(): string {
      return "ios-ui-" + this.type + (this.value ? " checked" : "");
    },
    getTextStyle(): StyleObject {
      return ({ color: this.disabled ? disabledTextColor : enabledTextColor }) as StyleObject;
    }
  },
  methods: {
    toggle() {
      if (!this.disabled) this.$emit("input", !this.value);
    }
  }
});
